var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"question__header"},[_c('p',[_vm._v(_vm._s(_vm.header))])]),_vm._v(" "),_c('img',{staticClass:"question__visual",attrs:{"src":_vm.baseUrl + _vm.visual}}),_vm._v(" "),_c('div',{staticClass:"question__text"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc738a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/minigames/swipequiz/Question.vue
// module id = u3Bt
// module chunks = 0